/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MRouteImport } from './routes/m'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MWebhooksRouteImport } from './routes/m.webhooks'
import { Route as MVerifyEmailRouteImport } from './routes/m.verify-email'
import { Route as MUsersRouteImport } from './routes/m.users'
import { Route as MSettlementsRouteImport } from './routes/m.settlements'
import { Route as MResetPasswordRouteImport } from './routes/m.reset-password'
import { Route as MProfileRouteImport } from './routes/m.profile'
import { Route as MPaymentsRouteImport } from './routes/m.payments'
import { Route as MOrgRouteImport } from './routes/m.org'
import { Route as MLoginRouteImport } from './routes/m.login'
import { Route as MIntegrationsRouteImport } from './routes/m.integrations'
import { Route as MGatewaysRouteImport } from './routes/m.gateways'
import { Route as MForgotPasswordRouteImport } from './routes/m.forgot-password'
import { Route as MDashboardRouteImport } from './routes/m.dashboard'
import { Route as MApiKeysRouteImport } from './routes/m.api-keys'
import { Route as DemoRequestRouteImport } from './routes/demo.request'
import { Route as DemoLoginRouteImport } from './routes/demo.login'
import { Route as AuthedWebhookVerificationRouteImport } from './routes/_authed/webhook-verification'
import { Route as AuthedUsersRouteImport } from './routes/_authed/users'
import { Route as AuthedSecurityRouteImport } from './routes/_authed/security'
import { Route as AuthedIntegrationsRouteImport } from './routes/_authed/integrations'
import { Route as AuthedGuideRouteImport } from './routes/_authed/guide'
import { Route as AuthedGatewaysRouteImport } from './routes/_authed/gateways'
import { Route as AuthedEventCatalogRouteImport } from './routes/_authed/event-catalog'
import { Route as AuthedDemoRequestsRouteImport } from './routes/_authed/demo-requests'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedAuditRouteImport } from './routes/_authed/audit'
import { Route as AuthedApiDocsRouteImport } from './routes/_authed/api-docs'
import { Route as AuthedSettlementsIndexRouteImport } from './routes/_authed/settlements.index'
import { Route as AuthedPaymentsIndexRouteImport } from './routes/_authed/payments.index'
import { Route as AuthedMerchantsIndexRouteImport } from './routes/_authed/merchants.index'
import { Route as MPaymentsIdRouteImport } from './routes/m.payments.$id'
import { Route as AuthedWebhooksDeliveriesRouteImport } from './routes/_authed/webhooks.deliveries'
import { Route as AuthedSettlementsFileIdRouteImport } from './routes/_authed/settlements.$fileId'
import { Route as AuthedPaymentsPaymentIdRouteImport } from './routes/_authed/payments.$paymentId'
import { Route as AuthedMerchantsMerchantIdRouteImport } from './routes/_authed/merchants.$merchantId'
import { Route as AuthedMerchantsMerchantIdUsersRouteImport } from './routes/_authed/merchants.$merchantId.users'

const MRoute = MRouteImport.update({
  id: '/m',
  path: '/m',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MWebhooksRoute = MWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => MRoute,
} as any)
const MVerifyEmailRoute = MVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => MRoute,
} as any)
const MUsersRoute = MUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => MRoute,
} as any)
const MSettlementsRoute = MSettlementsRouteImport.update({
  id: '/settlements',
  path: '/settlements',
  getParentRoute: () => MRoute,
} as any)
const MResetPasswordRoute = MResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => MRoute,
} as any)
const MProfileRoute = MProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => MRoute,
} as any)
const MPaymentsRoute = MPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => MRoute,
} as any)
const MOrgRoute = MOrgRouteImport.update({
  id: '/org',
  path: '/org',
  getParentRoute: () => MRoute,
} as any)
const MLoginRoute = MLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => MRoute,
} as any)
const MIntegrationsRoute = MIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => MRoute,
} as any)
const MGatewaysRoute = MGatewaysRouteImport.update({
  id: '/gateways',
  path: '/gateways',
  getParentRoute: () => MRoute,
} as any)
const MForgotPasswordRoute = MForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => MRoute,
} as any)
const MDashboardRoute = MDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => MRoute,
} as any)
const MApiKeysRoute = MApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => MRoute,
} as any)
const DemoRequestRoute = DemoRequestRouteImport.update({
  id: '/demo/request',
  path: '/demo/request',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoLoginRoute = DemoLoginRouteImport.update({
  id: '/demo/login',
  path: '/demo/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedWebhookVerificationRoute =
  AuthedWebhookVerificationRouteImport.update({
    id: '/webhook-verification',
    path: '/webhook-verification',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedUsersRoute = AuthedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSecurityRoute = AuthedSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedIntegrationsRoute = AuthedIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGuideRoute = AuthedGuideRouteImport.update({
  id: '/guide',
  path: '/guide',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGatewaysRoute = AuthedGatewaysRouteImport.update({
  id: '/gateways',
  path: '/gateways',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEventCatalogRoute = AuthedEventCatalogRouteImport.update({
  id: '/event-catalog',
  path: '/event-catalog',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDemoRequestsRoute = AuthedDemoRequestsRouteImport.update({
  id: '/demo-requests',
  path: '/demo-requests',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAuditRoute = AuthedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedApiDocsRoute = AuthedApiDocsRouteImport.update({
  id: '/api-docs',
  path: '/api-docs',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettlementsIndexRoute = AuthedSettlementsIndexRouteImport.update({
  id: '/settlements/',
  path: '/settlements/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPaymentsIndexRoute = AuthedPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMerchantsIndexRoute = AuthedMerchantsIndexRouteImport.update({
  id: '/merchants/',
  path: '/merchants/',
  getParentRoute: () => AuthedRoute,
} as any)
const MPaymentsIdRoute = MPaymentsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => MPaymentsRoute,
} as any)
const AuthedWebhooksDeliveriesRoute =
  AuthedWebhooksDeliveriesRouteImport.update({
    id: '/webhooks/deliveries',
    path: '/webhooks/deliveries',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettlementsFileIdRoute = AuthedSettlementsFileIdRouteImport.update({
  id: '/settlements/$fileId',
  path: '/settlements/$fileId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPaymentsPaymentIdRoute = AuthedPaymentsPaymentIdRouteImport.update({
  id: '/payments/$paymentId',
  path: '/payments/$paymentId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMerchantsMerchantIdRoute =
  AuthedMerchantsMerchantIdRouteImport.update({
    id: '/merchants/$merchantId',
    path: '/merchants/$merchantId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMerchantsMerchantIdUsersRoute =
  AuthedMerchantsMerchantIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthedMerchantsMerchantIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/m': typeof MRouteWithChildren
  '/api-docs': typeof AuthedApiDocsRoute
  '/audit': typeof AuthedAuditRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/demo-requests': typeof AuthedDemoRequestsRoute
  '/event-catalog': typeof AuthedEventCatalogRoute
  '/gateways': typeof AuthedGatewaysRoute
  '/guide': typeof AuthedGuideRoute
  '/integrations': typeof AuthedIntegrationsRoute
  '/security': typeof AuthedSecurityRoute
  '/users': typeof AuthedUsersRoute
  '/webhook-verification': typeof AuthedWebhookVerificationRoute
  '/demo/login': typeof DemoLoginRoute
  '/demo/request': typeof DemoRequestRoute
  '/m/api-keys': typeof MApiKeysRoute
  '/m/dashboard': typeof MDashboardRoute
  '/m/forgot-password': typeof MForgotPasswordRoute
  '/m/gateways': typeof MGatewaysRoute
  '/m/integrations': typeof MIntegrationsRoute
  '/m/login': typeof MLoginRoute
  '/m/org': typeof MOrgRoute
  '/m/payments': typeof MPaymentsRouteWithChildren
  '/m/profile': typeof MProfileRoute
  '/m/reset-password': typeof MResetPasswordRoute
  '/m/settlements': typeof MSettlementsRoute
  '/m/users': typeof MUsersRoute
  '/m/verify-email': typeof MVerifyEmailRoute
  '/m/webhooks': typeof MWebhooksRoute
  '/merchants/$merchantId': typeof AuthedMerchantsMerchantIdRouteWithChildren
  '/payments/$paymentId': typeof AuthedPaymentsPaymentIdRoute
  '/settlements/$fileId': typeof AuthedSettlementsFileIdRoute
  '/webhooks/deliveries': typeof AuthedWebhooksDeliveriesRoute
  '/m/payments/$id': typeof MPaymentsIdRoute
  '/merchants/': typeof AuthedMerchantsIndexRoute
  '/payments/': typeof AuthedPaymentsIndexRoute
  '/settlements/': typeof AuthedSettlementsIndexRoute
  '/merchants/$merchantId/users': typeof AuthedMerchantsMerchantIdUsersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/m': typeof MRouteWithChildren
  '/api-docs': typeof AuthedApiDocsRoute
  '/audit': typeof AuthedAuditRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/demo-requests': typeof AuthedDemoRequestsRoute
  '/event-catalog': typeof AuthedEventCatalogRoute
  '/gateways': typeof AuthedGatewaysRoute
  '/guide': typeof AuthedGuideRoute
  '/integrations': typeof AuthedIntegrationsRoute
  '/security': typeof AuthedSecurityRoute
  '/users': typeof AuthedUsersRoute
  '/webhook-verification': typeof AuthedWebhookVerificationRoute
  '/demo/login': typeof DemoLoginRoute
  '/demo/request': typeof DemoRequestRoute
  '/m/api-keys': typeof MApiKeysRoute
  '/m/dashboard': typeof MDashboardRoute
  '/m/forgot-password': typeof MForgotPasswordRoute
  '/m/gateways': typeof MGatewaysRoute
  '/m/integrations': typeof MIntegrationsRoute
  '/m/login': typeof MLoginRoute
  '/m/org': typeof MOrgRoute
  '/m/payments': typeof MPaymentsRouteWithChildren
  '/m/profile': typeof MProfileRoute
  '/m/reset-password': typeof MResetPasswordRoute
  '/m/settlements': typeof MSettlementsRoute
  '/m/users': typeof MUsersRoute
  '/m/verify-email': typeof MVerifyEmailRoute
  '/m/webhooks': typeof MWebhooksRoute
  '/merchants/$merchantId': typeof AuthedMerchantsMerchantIdRouteWithChildren
  '/payments/$paymentId': typeof AuthedPaymentsPaymentIdRoute
  '/settlements/$fileId': typeof AuthedSettlementsFileIdRoute
  '/webhooks/deliveries': typeof AuthedWebhooksDeliveriesRoute
  '/m/payments/$id': typeof MPaymentsIdRoute
  '/merchants': typeof AuthedMerchantsIndexRoute
  '/payments': typeof AuthedPaymentsIndexRoute
  '/settlements': typeof AuthedSettlementsIndexRoute
  '/merchants/$merchantId/users': typeof AuthedMerchantsMerchantIdUsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/m': typeof MRouteWithChildren
  '/_authed/api-docs': typeof AuthedApiDocsRoute
  '/_authed/audit': typeof AuthedAuditRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/demo-requests': typeof AuthedDemoRequestsRoute
  '/_authed/event-catalog': typeof AuthedEventCatalogRoute
  '/_authed/gateways': typeof AuthedGatewaysRoute
  '/_authed/guide': typeof AuthedGuideRoute
  '/_authed/integrations': typeof AuthedIntegrationsRoute
  '/_authed/security': typeof AuthedSecurityRoute
  '/_authed/users': typeof AuthedUsersRoute
  '/_authed/webhook-verification': typeof AuthedWebhookVerificationRoute
  '/demo/login': typeof DemoLoginRoute
  '/demo/request': typeof DemoRequestRoute
  '/m/api-keys': typeof MApiKeysRoute
  '/m/dashboard': typeof MDashboardRoute
  '/m/forgot-password': typeof MForgotPasswordRoute
  '/m/gateways': typeof MGatewaysRoute
  '/m/integrations': typeof MIntegrationsRoute
  '/m/login': typeof MLoginRoute
  '/m/org': typeof MOrgRoute
  '/m/payments': typeof MPaymentsRouteWithChildren
  '/m/profile': typeof MProfileRoute
  '/m/reset-password': typeof MResetPasswordRoute
  '/m/settlements': typeof MSettlementsRoute
  '/m/users': typeof MUsersRoute
  '/m/verify-email': typeof MVerifyEmailRoute
  '/m/webhooks': typeof MWebhooksRoute
  '/_authed/merchants/$merchantId': typeof AuthedMerchantsMerchantIdRouteWithChildren
  '/_authed/payments/$paymentId': typeof AuthedPaymentsPaymentIdRoute
  '/_authed/settlements/$fileId': typeof AuthedSettlementsFileIdRoute
  '/_authed/webhooks/deliveries': typeof AuthedWebhooksDeliveriesRoute
  '/m/payments/$id': typeof MPaymentsIdRoute
  '/_authed/merchants/': typeof AuthedMerchantsIndexRoute
  '/_authed/payments/': typeof AuthedPaymentsIndexRoute
  '/_authed/settlements/': typeof AuthedSettlementsIndexRoute
  '/_authed/merchants/$merchantId/users': typeof AuthedMerchantsMerchantIdUsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/m'
    | '/api-docs'
    | '/audit'
    | '/dashboard'
    | '/demo-requests'
    | '/event-catalog'
    | '/gateways'
    | '/guide'
    | '/integrations'
    | '/security'
    | '/users'
    | '/webhook-verification'
    | '/demo/login'
    | '/demo/request'
    | '/m/api-keys'
    | '/m/dashboard'
    | '/m/forgot-password'
    | '/m/gateways'
    | '/m/integrations'
    | '/m/login'
    | '/m/org'
    | '/m/payments'
    | '/m/profile'
    | '/m/reset-password'
    | '/m/settlements'
    | '/m/users'
    | '/m/verify-email'
    | '/m/webhooks'
    | '/merchants/$merchantId'
    | '/payments/$paymentId'
    | '/settlements/$fileId'
    | '/webhooks/deliveries'
    | '/m/payments/$id'
    | '/merchants/'
    | '/payments/'
    | '/settlements/'
    | '/merchants/$merchantId/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/m'
    | '/api-docs'
    | '/audit'
    | '/dashboard'
    | '/demo-requests'
    | '/event-catalog'
    | '/gateways'
    | '/guide'
    | '/integrations'
    | '/security'
    | '/users'
    | '/webhook-verification'
    | '/demo/login'
    | '/demo/request'
    | '/m/api-keys'
    | '/m/dashboard'
    | '/m/forgot-password'
    | '/m/gateways'
    | '/m/integrations'
    | '/m/login'
    | '/m/org'
    | '/m/payments'
    | '/m/profile'
    | '/m/reset-password'
    | '/m/settlements'
    | '/m/users'
    | '/m/verify-email'
    | '/m/webhooks'
    | '/merchants/$merchantId'
    | '/payments/$paymentId'
    | '/settlements/$fileId'
    | '/webhooks/deliveries'
    | '/m/payments/$id'
    | '/merchants'
    | '/payments'
    | '/settlements'
    | '/merchants/$merchantId/users'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/login'
    | '/m'
    | '/_authed/api-docs'
    | '/_authed/audit'
    | '/_authed/dashboard'
    | '/_authed/demo-requests'
    | '/_authed/event-catalog'
    | '/_authed/gateways'
    | '/_authed/guide'
    | '/_authed/integrations'
    | '/_authed/security'
    | '/_authed/users'
    | '/_authed/webhook-verification'
    | '/demo/login'
    | '/demo/request'
    | '/m/api-keys'
    | '/m/dashboard'
    | '/m/forgot-password'
    | '/m/gateways'
    | '/m/integrations'
    | '/m/login'
    | '/m/org'
    | '/m/payments'
    | '/m/profile'
    | '/m/reset-password'
    | '/m/settlements'
    | '/m/users'
    | '/m/verify-email'
    | '/m/webhooks'
    | '/_authed/merchants/$merchantId'
    | '/_authed/payments/$paymentId'
    | '/_authed/settlements/$fileId'
    | '/_authed/webhooks/deliveries'
    | '/m/payments/$id'
    | '/_authed/merchants/'
    | '/_authed/payments/'
    | '/_authed/settlements/'
    | '/_authed/merchants/$merchantId/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  MRoute: typeof MRouteWithChildren
  DemoLoginRoute: typeof DemoLoginRoute
  DemoRequestRoute: typeof DemoRequestRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/m': {
      id: '/m'
      path: '/m'
      fullPath: '/m'
      preLoaderRoute: typeof MRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/m/webhooks': {
      id: '/m/webhooks'
      path: '/webhooks'
      fullPath: '/m/webhooks'
      preLoaderRoute: typeof MWebhooksRouteImport
      parentRoute: typeof MRoute
    }
    '/m/verify-email': {
      id: '/m/verify-email'
      path: '/verify-email'
      fullPath: '/m/verify-email'
      preLoaderRoute: typeof MVerifyEmailRouteImport
      parentRoute: typeof MRoute
    }
    '/m/users': {
      id: '/m/users'
      path: '/users'
      fullPath: '/m/users'
      preLoaderRoute: typeof MUsersRouteImport
      parentRoute: typeof MRoute
    }
    '/m/settlements': {
      id: '/m/settlements'
      path: '/settlements'
      fullPath: '/m/settlements'
      preLoaderRoute: typeof MSettlementsRouteImport
      parentRoute: typeof MRoute
    }
    '/m/reset-password': {
      id: '/m/reset-password'
      path: '/reset-password'
      fullPath: '/m/reset-password'
      preLoaderRoute: typeof MResetPasswordRouteImport
      parentRoute: typeof MRoute
    }
    '/m/profile': {
      id: '/m/profile'
      path: '/profile'
      fullPath: '/m/profile'
      preLoaderRoute: typeof MProfileRouteImport
      parentRoute: typeof MRoute
    }
    '/m/payments': {
      id: '/m/payments'
      path: '/payments'
      fullPath: '/m/payments'
      preLoaderRoute: typeof MPaymentsRouteImport
      parentRoute: typeof MRoute
    }
    '/m/org': {
      id: '/m/org'
      path: '/org'
      fullPath: '/m/org'
      preLoaderRoute: typeof MOrgRouteImport
      parentRoute: typeof MRoute
    }
    '/m/login': {
      id: '/m/login'
      path: '/login'
      fullPath: '/m/login'
      preLoaderRoute: typeof MLoginRouteImport
      parentRoute: typeof MRoute
    }
    '/m/integrations': {
      id: '/m/integrations'
      path: '/integrations'
      fullPath: '/m/integrations'
      preLoaderRoute: typeof MIntegrationsRouteImport
      parentRoute: typeof MRoute
    }
    '/m/gateways': {
      id: '/m/gateways'
      path: '/gateways'
      fullPath: '/m/gateways'
      preLoaderRoute: typeof MGatewaysRouteImport
      parentRoute: typeof MRoute
    }
    '/m/forgot-password': {
      id: '/m/forgot-password'
      path: '/forgot-password'
      fullPath: '/m/forgot-password'
      preLoaderRoute: typeof MForgotPasswordRouteImport
      parentRoute: typeof MRoute
    }
    '/m/dashboard': {
      id: '/m/dashboard'
      path: '/dashboard'
      fullPath: '/m/dashboard'
      preLoaderRoute: typeof MDashboardRouteImport
      parentRoute: typeof MRoute
    }
    '/m/api-keys': {
      id: '/m/api-keys'
      path: '/api-keys'
      fullPath: '/m/api-keys'
      preLoaderRoute: typeof MApiKeysRouteImport
      parentRoute: typeof MRoute
    }
    '/demo/request': {
      id: '/demo/request'
      path: '/demo/request'
      fullPath: '/demo/request'
      preLoaderRoute: typeof DemoRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/login': {
      id: '/demo/login'
      path: '/demo/login'
      fullPath: '/demo/login'
      preLoaderRoute: typeof DemoLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/webhook-verification': {
      id: '/_authed/webhook-verification'
      path: '/webhook-verification'
      fullPath: '/webhook-verification'
      preLoaderRoute: typeof AuthedWebhookVerificationRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users': {
      id: '/_authed/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthedUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/security': {
      id: '/_authed/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof AuthedSecurityRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/integrations': {
      id: '/_authed/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AuthedIntegrationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/guide': {
      id: '/_authed/guide'
      path: '/guide'
      fullPath: '/guide'
      preLoaderRoute: typeof AuthedGuideRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/gateways': {
      id: '/_authed/gateways'
      path: '/gateways'
      fullPath: '/gateways'
      preLoaderRoute: typeof AuthedGatewaysRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/event-catalog': {
      id: '/_authed/event-catalog'
      path: '/event-catalog'
      fullPath: '/event-catalog'
      preLoaderRoute: typeof AuthedEventCatalogRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/demo-requests': {
      id: '/_authed/demo-requests'
      path: '/demo-requests'
      fullPath: '/demo-requests'
      preLoaderRoute: typeof AuthedDemoRequestsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/audit': {
      id: '/_authed/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthedAuditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/api-docs': {
      id: '/_authed/api-docs'
      path: '/api-docs'
      fullPath: '/api-docs'
      preLoaderRoute: typeof AuthedApiDocsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settlements/': {
      id: '/_authed/settlements/'
      path: '/settlements'
      fullPath: '/settlements/'
      preLoaderRoute: typeof AuthedSettlementsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/payments/': {
      id: '/_authed/payments/'
      path: '/payments'
      fullPath: '/payments/'
      preLoaderRoute: typeof AuthedPaymentsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/merchants/': {
      id: '/_authed/merchants/'
      path: '/merchants'
      fullPath: '/merchants/'
      preLoaderRoute: typeof AuthedMerchantsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/m/payments/$id': {
      id: '/m/payments/$id'
      path: '/$id'
      fullPath: '/m/payments/$id'
      preLoaderRoute: typeof MPaymentsIdRouteImport
      parentRoute: typeof MPaymentsRoute
    }
    '/_authed/webhooks/deliveries': {
      id: '/_authed/webhooks/deliveries'
      path: '/webhooks/deliveries'
      fullPath: '/webhooks/deliveries'
      preLoaderRoute: typeof AuthedWebhooksDeliveriesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settlements/$fileId': {
      id: '/_authed/settlements/$fileId'
      path: '/settlements/$fileId'
      fullPath: '/settlements/$fileId'
      preLoaderRoute: typeof AuthedSettlementsFileIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/payments/$paymentId': {
      id: '/_authed/payments/$paymentId'
      path: '/payments/$paymentId'
      fullPath: '/payments/$paymentId'
      preLoaderRoute: typeof AuthedPaymentsPaymentIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/merchants/$merchantId': {
      id: '/_authed/merchants/$merchantId'
      path: '/merchants/$merchantId'
      fullPath: '/merchants/$merchantId'
      preLoaderRoute: typeof AuthedMerchantsMerchantIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/merchants/$merchantId/users': {
      id: '/_authed/merchants/$merchantId/users'
      path: '/users'
      fullPath: '/merchants/$merchantId/users'
      preLoaderRoute: typeof AuthedMerchantsMerchantIdUsersRouteImport
      parentRoute: typeof AuthedMerchantsMerchantIdRoute
    }
  }
}

interface AuthedMerchantsMerchantIdRouteChildren {
  AuthedMerchantsMerchantIdUsersRoute: typeof AuthedMerchantsMerchantIdUsersRoute
}

const AuthedMerchantsMerchantIdRouteChildren: AuthedMerchantsMerchantIdRouteChildren =
  {
    AuthedMerchantsMerchantIdUsersRoute: AuthedMerchantsMerchantIdUsersRoute,
  }

const AuthedMerchantsMerchantIdRouteWithChildren =
  AuthedMerchantsMerchantIdRoute._addFileChildren(
    AuthedMerchantsMerchantIdRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedApiDocsRoute: typeof AuthedApiDocsRoute
  AuthedAuditRoute: typeof AuthedAuditRoute
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedDemoRequestsRoute: typeof AuthedDemoRequestsRoute
  AuthedEventCatalogRoute: typeof AuthedEventCatalogRoute
  AuthedGatewaysRoute: typeof AuthedGatewaysRoute
  AuthedGuideRoute: typeof AuthedGuideRoute
  AuthedIntegrationsRoute: typeof AuthedIntegrationsRoute
  AuthedSecurityRoute: typeof AuthedSecurityRoute
  AuthedUsersRoute: typeof AuthedUsersRoute
  AuthedWebhookVerificationRoute: typeof AuthedWebhookVerificationRoute
  AuthedMerchantsMerchantIdRoute: typeof AuthedMerchantsMerchantIdRouteWithChildren
  AuthedPaymentsPaymentIdRoute: typeof AuthedPaymentsPaymentIdRoute
  AuthedSettlementsFileIdRoute: typeof AuthedSettlementsFileIdRoute
  AuthedWebhooksDeliveriesRoute: typeof AuthedWebhooksDeliveriesRoute
  AuthedMerchantsIndexRoute: typeof AuthedMerchantsIndexRoute
  AuthedPaymentsIndexRoute: typeof AuthedPaymentsIndexRoute
  AuthedSettlementsIndexRoute: typeof AuthedSettlementsIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedApiDocsRoute: AuthedApiDocsRoute,
  AuthedAuditRoute: AuthedAuditRoute,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedDemoRequestsRoute: AuthedDemoRequestsRoute,
  AuthedEventCatalogRoute: AuthedEventCatalogRoute,
  AuthedGatewaysRoute: AuthedGatewaysRoute,
  AuthedGuideRoute: AuthedGuideRoute,
  AuthedIntegrationsRoute: AuthedIntegrationsRoute,
  AuthedSecurityRoute: AuthedSecurityRoute,
  AuthedUsersRoute: AuthedUsersRoute,
  AuthedWebhookVerificationRoute: AuthedWebhookVerificationRoute,
  AuthedMerchantsMerchantIdRoute: AuthedMerchantsMerchantIdRouteWithChildren,
  AuthedPaymentsPaymentIdRoute: AuthedPaymentsPaymentIdRoute,
  AuthedSettlementsFileIdRoute: AuthedSettlementsFileIdRoute,
  AuthedWebhooksDeliveriesRoute: AuthedWebhooksDeliveriesRoute,
  AuthedMerchantsIndexRoute: AuthedMerchantsIndexRoute,
  AuthedPaymentsIndexRoute: AuthedPaymentsIndexRoute,
  AuthedSettlementsIndexRoute: AuthedSettlementsIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface MPaymentsRouteChildren {
  MPaymentsIdRoute: typeof MPaymentsIdRoute
}

const MPaymentsRouteChildren: MPaymentsRouteChildren = {
  MPaymentsIdRoute: MPaymentsIdRoute,
}

const MPaymentsRouteWithChildren = MPaymentsRoute._addFileChildren(
  MPaymentsRouteChildren,
)

interface MRouteChildren {
  MApiKeysRoute: typeof MApiKeysRoute
  MDashboardRoute: typeof MDashboardRoute
  MForgotPasswordRoute: typeof MForgotPasswordRoute
  MGatewaysRoute: typeof MGatewaysRoute
  MIntegrationsRoute: typeof MIntegrationsRoute
  MLoginRoute: typeof MLoginRoute
  MOrgRoute: typeof MOrgRoute
  MPaymentsRoute: typeof MPaymentsRouteWithChildren
  MProfileRoute: typeof MProfileRoute
  MResetPasswordRoute: typeof MResetPasswordRoute
  MSettlementsRoute: typeof MSettlementsRoute
  MUsersRoute: typeof MUsersRoute
  MVerifyEmailRoute: typeof MVerifyEmailRoute
  MWebhooksRoute: typeof MWebhooksRoute
}

const MRouteChildren: MRouteChildren = {
  MApiKeysRoute: MApiKeysRoute,
  MDashboardRoute: MDashboardRoute,
  MForgotPasswordRoute: MForgotPasswordRoute,
  MGatewaysRoute: MGatewaysRoute,
  MIntegrationsRoute: MIntegrationsRoute,
  MLoginRoute: MLoginRoute,
  MOrgRoute: MOrgRoute,
  MPaymentsRoute: MPaymentsRouteWithChildren,
  MProfileRoute: MProfileRoute,
  MResetPasswordRoute: MResetPasswordRoute,
  MSettlementsRoute: MSettlementsRoute,
  MUsersRoute: MUsersRoute,
  MVerifyEmailRoute: MVerifyEmailRoute,
  MWebhooksRoute: MWebhooksRoute,
}

const MRouteWithChildren = MRoute._addFileChildren(MRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  MRoute: MRouteWithChildren,
  DemoLoginRoute: DemoLoginRoute,
  DemoRequestRoute: DemoRequestRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
